import { Trash2 } from 'lucide-react';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import { Button } from '~shared/shadcn/ui/button';
import { Card, CardContent } from '~shared/shadcn/ui/card';
import { Input } from '~shared/shadcn/ui/input';
import { Label } from '~shared/shadcn/ui/label';

export interface RangeFormValues {
  minMinute: number;
  maxMinute: number;
  flatRate: number;
}

interface FormValues {
  name: string;
  ranges: Array<RangeFormValues>;
}

interface HourlyTuitionRangeRowProps {
  index: number;
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  canDelete: boolean;
  onDelete: () => void;
}

export const HourlyTuitionRangeRow = ({
  index,
  register,
  errors,
  canDelete,
  onDelete,
}: HourlyTuitionRangeRowProps) => {
  return (
    <Card>
      <CardContent className='p-4'>
        <div className='flex items-center gap-4'>
          <div className='grid flex-1 grid-cols-3 gap-3'>
            <div className='space-y-1'>
              <Label className='text-sm text-muted-foreground'>
                Min Minutes
              </Label>
              <Input
                type='number'
                {...register(`ranges.${index}.minMinute`, {
                  valueAsNumber: true,
                })}
                min='0'
              />
              {errors.ranges?.[index]?.minMinute && (
                <p className='mt-1 text-xs text-red-500'>
                  {errors.ranges[index].minMinute.message}
                </p>
              )}
            </div>
            <div className='space-y-1'>
              <Label className='text-sm text-muted-foreground'>
                Max Minutes
              </Label>
              <Input
                type='number'
                {...register(`ranges.${index}.maxMinute`, {
                  valueAsNumber: true,
                })}
                min='0'
              />
              {errors.ranges?.[index]?.maxMinute && (
                <p className='mt-1 text-xs text-red-500'>
                  {errors.ranges[index].maxMinute.message}
                </p>
              )}
            </div>
            <div className='space-y-1'>
              <Label className='text-sm text-muted-foreground'>
                Flat Rate ($)
              </Label>
              <Input
                type='number'
                {...register(`ranges.${index}.flatRate`, {
                  valueAsNumber: true,
                })}
                min='0'
                step='0.01'
              />
              {errors.ranges?.[index]?.flatRate && (
                <p className='mt-1 text-xs text-red-500'>
                  {errors.ranges[index].flatRate.message}
                </p>
              )}
            </div>
          </div>

          {canDelete && (
            <Button
              type='button'
              variant='ghost'
              size='sm'
              onClick={onDelete}
              className='h-fit p-0 text-destructive hover:text-destructive'
            >
              <Trash2 className='size-4' />
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
